export const dialogTimer: number = 5000;
export const dialogAnimationDuration: number = 200;
export const dialogWidth: number = 700;
export const dialogHeight: number = 300;
export const dialogMinWidth: number = 700;
export const dialogLongTimer: number = 10000;